//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

// Headerスクロール時
import {scrolledHeader} from "../include/module";
scrolledHeader();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

const resposiveProduct = () => {
  const windowWidth = window.innerWidth;
  const target = document.querySelectorAll('.js-Product_List');

  for (let i = 0; i < target.length; i++) {
    const targetChild = target[i].querySelector('.js-Product_List ul li');
    const listWidth = targetChild.offsetWidth + 10;
    const listNumber = windowWidth / listWidth;
    const targetWidth = listWidth * Math.floor(listNumber) - 10;
    target[i].style.width = targetWidth + 'px';
  }
};
resposiveProduct();
window.addEventListener('resize',function(){
  resposiveProduct();
});

// swiper
const slider = () => {
  const el = document.querySelector('.swiper-container');

  if(!el){
    return false;
  }

  const sliderLength = el.querySelectorAll('.swiper-wrapper li').length;
  const settings = {
    centeredSlides: true,
    speed: 800,
    watchOverflow: true,
    slidesPerView: 1,
    direction: 'horizontal',
    loop: false,
    loopAdditionalSlides: sliderLength,
    breakpoints: {
      1024: {
        slidesPerView: 1,
        loopAdditionalSlides: 1,
      }
    },
  }

  let swiper;
  swiper = new Swiper (el, settings);

  swiper.on('slideChangeTransitionStart', function() {
    $('.swiper-thumbs ul li.active').removeClass('active');
    $('.swiper-thumbs ul li').eq(swiper.activeIndex).addClass('active');
  });

  $('.swiper-thumbs ul li').on('touchstart mousedown', function() {
    $('.swiper-thumbs ul li.active').removeClass('active')
    $(this).addClass('active')
    swiper.slideTo($(this).index())
  });
};
slider();

// luminous
const luminous = () => {
  const luminousTrigger = document.querySelectorAll('.luminous');
  const length = luminousTrigger.length;

  const options = {
    namespace: null,
    sourceAttribute: 'href',
    caption: (trigger) => {
      const ul = trigger.parentNode.parentNode;
      const li = ul.querySelectorAll("li");
      let number = Array.prototype.indexOf.call(li, trigger.parentNode) + 1;
      return number + "/" + length;
    },
    openTrigger: 'click',
    closeTrigger: 'click',
    closeWithEscape: true,
    closeOnScroll: false,
    showCloseButton: true,
    appendToSelector: 'body',
    onOpen: null,
    onClose: null,
    includeImgixJSClass: false,
    injectBaseStyles: true,
  };

  const galleryOpts = {
    arrowNavigation: false,
  };

  if( luminousTrigger !== null ) {
    new LuminousGallery(luminousTrigger, galleryOpts, options);
  }

  $('.luminous').on('click', function(){
    $('.lum-open').each(function(){
      if($(this).find('.lum-gallery-button-wrapper').length === 0){
        $(this).find('.lum-gallery-button').wrapAll('<div class="lum-gallery-button-wrapper"></div>');
        $(this).find('.lum-gallery-button-wrapper').appendTo($(this).find('.lum-lightbox-position-helper'));
      }
    });
  });
}
luminous();



// WEBPACK FOOTER //
// ./src/stronger/assets/js/figure/script.js